import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../../common/hooks/useAuth';

function AuthenticatedRoute({ children }) {
  const { isAuth } = useAuth();
  const location = useLocation();

  if (isAuth) {
    return children;
  }

  // Send the user to the login page and bring them back here afterwards.
  return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
}

export default AuthenticatedRoute;
